export default __webpack_public_path__ + "static/52-100-073971718935bf53e8fad13593ce8e97.jpg";